import React from 'react'
import Link from 'gatsby-link'

import Header from '../components/Header'
import HeaderInfo from '../components/HeaderInfo'
import About from '../components/About'
import Tickets from '../components/Tickets'
import Venue from '../components/Venue'
import Sponsors from '../components/Sponsors'
import Speakers from '../components/Speakers'
import Schedule from '../components/Schedule'
import Team from '../components/Team'
import Footer from '../components/Footer'
import Backgrounds from '../components/Backgrounds'

const IndexPage = () => (
  <div className="wrapper">
    <div className="wrapper-main wrapper-main_hero">
      <Header />
      <h1 className="wrapper-main_title">CSSConf.<br />Argentina</h1>
      <HeaderInfo />
    </div>
    <div className="wrapper-main">
      <About className="wrapper-main_about" />
    </div>
    <div className="wrapper-main">
      <Speakers />
      <Schedule />
    </div>
    <Tickets className="wrapper-main_tickets" />
    <div className="wrapper-main">
      <Venue className="wrapper-main_venue" />
    </div>
    <Sponsors />
    <Team className="wrapper-main_team" />
    <div className="wrapper-main">
      <Footer className="wrapper-main_footer" />
    </div>
    <Backgrounds />
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js